import ReactEcharts from "echarts-for-react";
import { useRef } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Agent from "../../../Network/Agent";
import nProgress from "nprogress";
export default function MainsFail({ title, id, bar_color }) {
    const echarts_react_1 = useRef();
    const [metricType, setMetricType] = useState('site'); // 'site' or 'alarm'

    const dispatch = useDispatch();
    const [filter, setFilter] = useState("daily");
    const [labels, setLabels] = useState([]);
    const [array_count, setAcData] = useState([]);
    const [array_duration, setDuration] = useState([]);
    const [site_id, setSiteId] = useState();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selected, setSelected] = useState('Last 30 Days');
    const chartInstance = echarts_react_1.current?.getEchartsInstance();
    const array_data = {
        site_id: site_id || '',
        alarm_id: id,
        from_date: startDate,
        to_date: endDate,
        filter_type: filter,
        metric: metricType
    };

    function onchangeSite(value) {
        array_data.site_id = value;
        setSiteId(value);
        fetchData();
    }

    function onchangeMetricType(value) {
        array_data.metric = value;
        setMetricType(value);
        fetchData();
    }

    const fetchData = async () => {
        chartInstance?.showLoading('default', {
            text: 'Loading...',
            color: '#5470C6',
            textColor: '#000',
            maskColor: 'rgba(255, 255, 255, 0.8)',
            zlevel: 0
        });
        Agent.MANAGEMENT_DASHBOARD.alarm_frequency(array_data).then((res) => {
            chartInstance?.hideLoading();
            setLabels(res.data.data.label);
            setAcData(res.data.data.count);
            setDuration(res.data.data.duration);

        }).catch((error) => {
            console.error("Error fetching power availability data:", error);
        });
    };


    // Fetch data when the component mounts or when the filter changes

    useEffect(() => {
        if (site_id) {
            array_data.site_id = site_id;
        } else {
            array_data.site_id = '';
        }

        array_data.filter_type = filter;
        if (filter === "custom") {
            setShowModal(true);
            return;
        }
        else {
            setShowModal(false);
        }

        fetchData();

    }, [filter]);

    const labelOption = {
        show: false,
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'top',
        formatter: '{c}',

        fontSize: 12,
        rich: {
            name: {}
        }
    };
    const labelOption2 = {
        show: true,
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'top',
        formatter: '{c}h',

        fontSize: 12,
        rich: {
            name: {}
        }
    };
    const mainLabel = metricType === 'site' ? 'Number Of Sites' : 'Alarm Count';
    const siteMax = Math.max(...array_count);
    const alarmMax = Math.max(...array_count);

    const option = {
        title: {
            text: '',
            subtext: ''
        },
        tooltip: {
            trigger: 'axis',
        },
        legend: {
            data: [mainLabel, 'Duration']
        },
        toolbox: {
            show: true,
            feature: {

                saveAsImage: { show: true }
            }
        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                data: labels,
                axisLabel: {
                    interval: 2,
                    rotate: 45,
                    fontSize: 12
                },
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                axisTick: {
                    alignWithLabel: true
                },
                boundaryGap: true,

            }
        ],
        yAxis: [
            {
                name: metricType === 'site' ? 'Number Of Sites' : 'Alarm Count',
                nameLocation: 'middle',
                nameGap: 50,
                nameTextStyle: {
                    fontWeight: 'bold',
                    color: '#000000'
                },
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisLabel: {
                    formatter: '{value}'
                },
                axisPointer: {
                    snap: true
                },


            }
        ],
        series: [
            {
                name: metricType === 'site' ? 'Number Of Sites' : 'Alarm Count',
                type: 'line',
                data: array_count,
                label: labelOption
            },
            {
                name: 'Duration',
                type: 'bar',
                data: array_duration,
                label: labelOption2,
                itemStyle: {
                    color: bar_color
                }
            }
        ]
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Get the start and end dates from the form
        const startDateInput = e.target.startDate.value;
        const endDateInput = e.target.endDate.value;
        // Validate date range
        if (!startDateInput || !endDateInput) {
            alert("Please select both start and end dates.");
            return;
        }
        if (startDateInput > endDateInput) {
            alert("Start date cannot be later than end date.");
            return;
        }
        // Update array_data with selected dates
        if (startDateInput && endDateInput) {
            array_data.from_date = startDateInput;
            array_data.to_date = endDateInput;
            array_data.filter_type = 'custom';
            setStartDate(new Date(startDateInput));
            setEndDate(new Date(endDateInput));
            setShowModal(false);
            fetchData();
        }
    }

    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5>{title}</h5>
                    <div className="d-flex gap-2">


                        <div class="dropdown">
                            <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown">
                                {metricType === 'site' ? 'Number of Sites' : 'Number of Alarm Count'}
                            </button>
                            <ul class="dropdown-menu">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            onchangeMetricType("site");

                                        }}
                                    >
                                        Number of Sites
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            onchangeMetricType("alarm");

                                        }}
                                    >
                                        Number of Alarm Count
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div className="dropdown">
                            <button
                                className="btn dropdown-toggle"
                                type="button"
                                id="filterDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {selected}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="filterDropdown">
                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            setFilter("daily");
                                            setSelected("Last 30 Days");
                                        }}
                                    >
                                        Last 30 Days
                                    </button>
                                </li>

                                <li>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => {
                                            setFilter("custom");
                                            setSelected("Date Range");
                                            setShowModal(true);
                                        }}
                                    >
                                        Date Range
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="dropdown">
                            <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown">
                                Export
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#">CSV</a></li>
                                <li><a class="dropdown-item" href="#">XLSX</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card-body p-0 m-0">
                    <ReactEcharts ref={echarts_react_1} style={{ height: "300px" }} option={option} />

                </div>
            </div>

            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Custom Date Range</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSubmit} id="add_country_form">

                                <div className="modal-body">
                                    <div className="mb-2">
                                        <label className="form-label">From Date</label>
                                        <input
                                            type="date"
                                            name="startDate"
                                            className="form-control"

                                            onChange={(e) => setStartDate(new Date(e.target.value))}
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label">To Date</label>
                                        <input
                                            type="date"
                                            name="endDate"
                                            className="form-control"
                                            onChange={(e) => setEndDate(new Date(e.target.value))}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>Cancel</button>
                                    <button
                                        className="btn btn-info btn-sm"
                                        disabled={!startDate || !endDate}
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}